import { useAppSelector } from "./reduxHooks";
import { ApplicationState } from "store";
import { FeatureToggles, FeatureToggleValue, KnownFeatureToggles, ToggleableFeature } from "modules/features/models";

export const useFeatureToggles = (): FeatureToggles =>
    useAppSelector((state: ApplicationState) => state.features.featureToggles);

export const useFeatureToggle = (knownFeatureToggle: KnownFeatureToggles): ToggleableFeature | null =>
    useAppSelector((state: ApplicationState) => state.features.featureToggles[knownFeatureToggle] || null);

export const useIsFeatureEnabled = (knownFeatureToggle: KnownFeatureToggles): boolean =>
    useAppSelector(
        (state: ApplicationState) =>
            state.features.featureToggles[knownFeatureToggle]?.toggleValue === FeatureToggleValue.On
    );
